import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import styles from "../index.module.css";

const STEPS = [
  {
    key: "submitted",
    label: "Application Submitted",
    sub: "Documents received",
    done: true,
  },
  {
    key: "kyc",
    label: "KYC Verified",
    sub: "Identity confirmed",
    done: true,
  },
  {
    key: "agreement",
    label: "Agreement Signed",
    sub: "Loan terms accepted",
    done: true,
  },
  {
    key: "disbursement",
    label: "Funds Disbursement",
    sub: "Processing in progress...",
    done: false,
  },
];

function EligibilityApplicationSuccess() {
  const location = useLocation();
  const userData =
    location.state?.data ||
    JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");


  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.main}>
          <div className={styles.cardWrapper}>
            <div className={styles.container}>

              {/* ── Success Badge ── */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "0.5rem", paddingBottom: "0.6rem" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, #d32028 0%, #a01820 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(211,32,40,0.28)",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path
                      d="M8 18L15 25L28 11"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* <p
                  style={{
                    fontSize: "1.35rem",
                    fontWeight: 800,
                    color: "#1a1a2e",
                    margin: "0 0 0.35rem",
                    fontFamily: "Outfit, sans-serif",
                    textAlign: "center",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Application Successful!
                </p> */}
                <p
                  style={{
                    fontSize: "0.84rem",
                    color: "#777",
                    margin: 0,
                    textAlign: "center",
                    lineHeight: 1.55,
                    whiteSpace: "nowrap",
                  }}
                >
                  Disbursement will be processed shortly.
                </p>
                <div
                  style={{
                    marginTop: "0.75rem",
                    background: "#2563eb",
                    color: "#fff",
                    borderRadius: "60px",
                    padding: "0.5rem 1.2rem",
                    fontSize: "0.88rem",
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.4rem",
                    boxShadow: "0 4px 14px rgba(37,99,235,0.35)",
                  }}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
                  </svg>
                  You can close this window
                </div>
              </div>

              {/* ── Status Tracker ── */}
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #e8e8e8",
                  borderRadius: "14px",
                  padding: "1rem 1.15rem",
                  marginBottom: "0.9rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.45rem",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="#888" strokeWidth="1.6" />
                    <path d="M12 7V12L15 14.5" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span
                    style={{
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      color: "#888",
                      letterSpacing: "0.9px",
                      textTransform: "uppercase",
                    }}
                  >
                    Status Tracker
                  </span>
                </div>

                <div style={{ position: "relative" }}>
                  {/* Vertical connector line */}
                  <div
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "20px",
                      bottom: "28px",
                      width: "2px",
                      background: "linear-gradient(to bottom, #d32028 66%, #e0e0e0 66%)",
                      zIndex: 0,
                    }}
                  />

                  {STEPS.map((step, idx) => (
                    <div
                      key={step.key}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "0.85rem",
                        marginBottom: idx < STEPS.length - 1 ? "0.5rem" : 0,
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      {/* Step icon */}
                      {step.done ? (
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            background: "#d32028",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,marginTop:'0.5rem'
                          }}
                        >
                          <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
                            <path
                              d="M3 7L6 10L11 4"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      ) : (
                        /* Pulsing "in progress" dot */
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            border: "2.5px solid #d32028",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,marginTop:'0.5rem'
                          }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "10px",
                              borderRadius: "50%",
                              background: "#d32028",
                              animation: "pulse 1.4s ease-in-out infinite",
                            }}
                          />
                        </div>
                      )}

                      {/* Step text */}
                      <div >
                        <p
                          style={{
                            margin: "0 0 0rem",
                            fontSize: "0.9rem",
                            fontWeight: 700,
                            color: step.done ? "#1a1a2e" : "#d32028",
                            fontFamily: "Outfit, sans-serif",
                          }}
                        >
                          {step.label}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "0.74rem",
                            color: step.done ? "#888" : "#d32028",
                            opacity: step.done ? 1 : 0.8,
                          }}
                        >
                          {step.sub}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ── Disbursement note ── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.65rem",
                  background: "#fff8f8",
                  border: "1px solid #f9d8d6",
                  borderRadius: "10px",
                  padding: "0.8rem 0.9rem",
                  marginBottom: "0.2rem",
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: "1px" }}>
                  <circle cx="12" cy="12" r="9" stroke="#d32028" strokeWidth="1.7" />
                  <path d="M12 11V16" stroke="#d32028" strokeWidth="1.8" strokeLinecap="round" />
                  <circle cx="12" cy="8" r="0.8" fill="#d32028" />
                </svg>
                <p style={{ margin: 0, fontSize: "0.60rem", color: "#555", lineHeight: 1.6 }}>
                  Disbursement usually takes{" "}
                  <strong style={{ color: "#d32028", textDecoration: "underline" }}>2–4 hours</strong>
                  . We will notify you once the transfer is successful.
                </p>
              </div>

              {/* Pulse animation */}
              <style>{`
                @keyframes pulse {
                  0%, 100% { transform: scale(1); opacity: 1; }
                  50% { transform: scale(1.3); opacity: 0.6; }
                }
              `}</style>
            </div>

          <Footer light />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EligibilityApplicationSuccess;
